import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

export class GetDealerService extends Service {
  constructor({repository}) {
    super()

    this._repository = repository
  }

  @inlineError
  async execute({requestVO}) {
    const [error, dealerEntity] = await this._repository.getDealer({requestVO})

    if (error) return Promise.reject(error)

    return dealerEntity
  }
}
